
import { defineComponent, PropType } from 'vue';
import { OfferDisplayType } from 'JS/helpers/promo-helpers';

export default defineComponent({
	name: 'PromoOfferDiscountLine',
	components: {},
	props: {
		type: { type: String as PropType<OfferDisplayType>, default: 'normal' },
		description: { type: String, required: true },
		amount: String,
		monochrome: Boolean,
		amountIsHidden: Boolean,
	},
});
